import React, { useState } from 'react'
import { Collapse, Button } from '@material-ui/core'
import { ChevronDown, ChevronUp } from 'lucide-react'

const CollapsePanelV2 = ({ title = 'Toggle', children }) => {
  const [open, setOpen] = useState(false)

  return (
    <div className="w-full rounded-8 border border-grey-input text-blue-950 bg-white text-18">
      <Button
        className="w-full flex justify-between text-blue-950 text-14 h-50"
        onClick={() => setOpen(!open)}
        type="button"
      >
        {title}
        {open ? (
          <ChevronUp className="w-20" />
        ) : (
          <ChevronDown className="w-20" />
        )}
      </Button>
      <Collapse in={open}>
        <div className="p-5">{children}</div>
      </Collapse>
    </div>
  )
}

export default CollapsePanelV2
